<template>
  <v-card class="d-flex pa-2 flex-column" outlined>
    <v-alert
      v-model="flashError"
      dense
      border="left"
      type="error"
      dismissible
      elevation="2"
    >
      {{ flashErrorMessage }}
    </v-alert>

    <table-filter
      :search="search"
      v-on:clearSearchParent="clearSearch"
      v-on:getDataParent="handleChangeFilter"
      :loading="loading"
    />

    <v-data-table
      :headers="headers"
      fixed-header
      :items="allData"
      :options.sync="options"
      :server-items-length="totalData"
      :loading="loading"
      loading-text="Loading... Please wait"
      :item-class="rowClass"
      class="d-print-table table-list"
      :footer-props="{
        itemsPerPageOptions: [5, 10, 25, 50],
        // showFirstLastPage: true,
      }"
      item-key="id"
      sort-by="count_duplicate"
      :sort-desc="true"
      :style="{ padding: '10px', height: '70vh' }"
      @click:row="selectRow"
    >
      <template v-slot:top>
        <table-top-vue
          :loading="loading"
          :listButton="listButton"
          v-on:getDataParent="handleChangeFilter"
        />
      </template>
      <template v-slot:[`item.id`]="{ index }">
        {{ (options.page - 1) * options.itemsPerPage + index + 1 }}
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="clearSearch"> Reset </v-btn>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { date } from '../../lib/helpers';

export default {
  components: {
    TableFilter: () => import('../../components/table/DuplicateMidFilter.vue'),
    TableTopVue: () => import('../../components/table/TableTop.vue'),
  },
  data: () => ({
    listButton: {
      buttonRestart: true,
    },
    switchCh: true,
    today: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .slice(0, 10),
    isFirstLoad: false,
    options: {},
    dialog: false,
    headers: [
      {
        text: 'No',
        align: 'start',
        value: 'id',
        sortable: false,
        width: '10',
      },
      {
        text: 'MID',
        value: 'duplicate_mid',
        width: '150',
        sortable: false,
        align: 'left',
      },
      {
        text: 'Count Duplicate',
        value: 'count_duplicate',
        width: '150',
        sortable: false,
        align: 'center',
      },
    ],
    search: {
      mid: '',
    },
    editedItem: {
      mid: '',
    },
    editedIndex: -1,
  }),

  computed: {
    allData() {
      return this.$store.state.mid.duplicateMid.allData;
    },
    totalData() {
      return this.$store.state.mid.duplicateMid.totalData;
    },
    totalPage() {
      return this.$store.state.mid.duplicateMid.totalPage;
    },
    loading() {
      return this.$store.state.mid.duplicateMid.loading;
    },
    flashError: {
      get() {
        return this.$store.state.mid.duplicateMid.flashError;
      },
      set() {
        this.$store.commit('mid/duplicateMid/setFlashErrorMessage', '');
      },
    },
    flashErrorMessage() {
      return this.$store.state.mid.duplicateMid.flashErrorMessage;
    },
  },

  watch: {
    options: {
      handler() {
        if (!this.isFirstLoad) {
          this.handleChangeFilter();
        } else {
          this.$store.commit('mid/duplicateMid/clearData');
        }
        this.isFirstLoad = false;
      },
      deep: true,
    },
  },

  methods: {
    selectRow(item) {
      this.viewItem(item.duplicate_mid);
    },

    rowClass() {
      const rowClass = 'max-width-col';
      return rowClass;
    },

    handleChangeFilter() {
      const filter = {};

      if (this.$route.query.mid) {
        filter.mid = this.$route.query.mid;
      }

      this.search = { ...this.search, ...filter };

      this.getData();
    },

    getData() {
      const source = this.checkEnvCh;
      this.$store.commit('mid/duplicateMid/setFlashErrorMessage', '');
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      this.$store
        .dispatch('mid/duplicateMid/getData', {
          date,
          page,
          itemsPerPage,
          sortBy,
          sortDesc,
          search: this.search,
          source,
        })
        .then(() => {
          if (this.totalPage < page) {
            if (this.totalPage == 0) {
              this.options.page = 1;
            } else {
              this.options.page = this.totalPage;
            }
          }
        });
    },

    async viewItem(itemId) {
      this.$router.push(`/duplicate-mid/list/detail/${itemId}`);
    },

    closeFlash() {
      this.$store.commit('mid/duplicateMid/setFlashErrorMessage', '');
    },

    clearSearch() {
      this.search.mid = '';
      this.$nextTick(() => {
        this.$router.push({ query: { ...this.search } });
        this.$store.commit('mid/duplicateMid/clearData');
        this.handleChangeFilter();
      });
    },
  },
};
</script>

<style>
.max-width-col td {
  white-space: nowrap;
  overflow: hidden;
  max-width: 250px;
  text-overflow: ellipsis;
}
.v-data-table .v-data-table__wrapper {
  height: 100%;
}
.table-list tr {
  cursor: pointer;
}
</style>
